import { render, staticRenderFns } from "./ExplicitTopicLink.vue?vue&type=template&id=dd99ed64&scoped=true&"
import script from "./ExplicitTopicLink.vue?vue&type=script&lang=js&"
export * from "./ExplicitTopicLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd99ed64",
  null
  
)

export default component.exports